var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("modal-pop", {
        attrs: {
          opened: _vm.lvbdInfoRegiYnPopupOpen,
          modalHeader: true,
          modalFooter: true,
          btnClose: true,
          titleCenter: true,
          title: /*생체정보검증*/ _vm.$t("FIDO-0016")
        },
        on: {
          "update:opened": function($event) {
            _vm.lvbdInfoRegiYnPopupOpen = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      /*해당 거래는 생체정보검증이 필요합니다.*/ _vm.$t(
                        "FIDO-0029"
                      )
                    ) +
                    " " +
                    _vm._s(
                      /*생체정보 등록 후 다시 거래해주시기 바랍니다.*/ _vm.$t(
                        "FIDO-0030"
                      )
                    ) +
                    " "
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function() {
                        _vm.$router.push({ name: "createEkycEnter" })
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*등록하기*/ _vm.$t("FIDO-0031")))]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("modal-pop", {
        staticClass: "modal",
        attrs: {
          opened: _vm.scanSelfieDataNoMatch,
          modalHeader: true,
          modalFooter: true,
          title: /*생체정보검증*/ _vm.$t("FIDO-0016")
        },
        on: {
          "update:opened": function($event) {
            _vm.scanSelfieDataNoMatch = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("div", [
                  _c("div", { staticClass: "ekyc content-header" }, [
                    _c("div", { staticClass: "title-img" }, [
                      _c("i", { staticClass: "icon icon-img-char02" })
                    ]),
                    _c("div", { staticClass: "title" }, [
                      _c("h5", [
                        _vm._v(_vm._s(/*죄송합니다.*/ _vm.$t("FIDO-0022")))
                      ])
                    ]),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            /*생체정보검증에 실패하였습니다.*/ _vm.$t(
                              "FIDO-0023"
                            )
                          ) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(
                        " " +
                          _vm._s(
                            /*재시도하거나 영업점에 방문해주시기 바랍니다.*/ _vm.$t(
                              "FIDO-0024"
                            )
                          ) +
                          " "
                      )
                    ])
                  ])
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn bottom positive",
                    on: {
                      click: function($event) {
                        _vm.scanSelfieDataNoMatch = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(/*확인*/ _vm.$t("FIDO-0025")))]
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }